import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  form: {
    background: "transparent",
  },
  paper: {
    borderRadius: "8px",
    backgroundColor: theme.palette.otherElementsBackground.main,
    color: theme.palette.contrastText.main,
    width: "35vw",
    outline: "none !important",
    "&:focus": {
      outline: "none !important",
    },
  },
  header: {
    padding: `${theme.spacing(3)}px 0 0 ${theme.spacing(3)}px`,
  },
  errorText: {
    marginTop: theme.spacing(1),
  },
  info: {
    marginTop: theme.spacing(2.5),
  },
}));
